// Always use plural values
// API_KEYS: api_keys <--- CORRECT
// API_KEYS: api_key <--- INCORRECT

export enum DB_COLLECTION_NAMES {
  // A
  ARTICLES = 'articles',
  ARTICLE_CATEGORIES = 'article_categories',
  ARTICLE_SUB_CATEGORIES = 'article_sub_categories',
  ARTICLE_TAGS = 'article_tags',
  ACCESS_CREDENTIALS = 'access_credentials',
  API_KEYS = 'api_keys',
  ARTICLE_BLOG = 'article_blog',
  ARTICLE_NEWS = 'article_news',
  ARTICLE_CASE_STUDIES = 'article_case_studies',
  ATTENDANCE = 'attendance',
  ATTENDANCE_CONFIGURATIONS = 'attendance_configurations',

  ARTICLE_EVENTS = 'article_events',
  // B
  BOOKINGS = 'bookings',

  // C
  CONNECTED_APPS = 'connected_apps',
  CONNECTIONS = 'connections',
  CONSULTATIONS = 'consultations',
  CONSULTATION_CONFIGURATIONS = 'consultation_configurations',
  AUTH_REQUESTS = 'auth_requests',
  AUTH_CODES = 'auth_codes',

  // D
  DELETED_CLIENT_SECRETS = 'deleted_client_secrets',
  DELETED_API_KEYS = 'deleted_api_keys',
  // E
  ERROR_LOGS = 'error_logs',
  EMPLOYEE = 'employee',
  MAILBOX_CONFIG = 'mailbox_config',

  // H
  HOLIDAY = 'holidays',

  // I
  IDENTITIES = 'identities',
  INTEGRATION_ENDPOINTS = 'integration_endpoints',
  INTEGRATION_MAPPINGS = 'integration_mappings',
  INVENTORY = 'inventories',
  // L
  LOGS = 'logs',
  // M
  MESSAGES = 'messages',
  MESSAGES_RESPONSES = 'messages_responses',
  MODULES = 'modules',
  // N
  NOTIFICATIONS = 'notifications',
  NOTIFICATION_IDENTITIES = 'notification_identities',
  NOTICES = 'notices',
  // O
  OTP = 'otps',
  // P
  PERMISSIONS = 'permissions',
  PRIVILEGES = 'privileges',
  POST_IT_NOTES = 'post-it-notes',
  PERSONALIZATIONS = 'personalizations',
  PREDEFINED_REFERENCES_COUNTRIES = 'predefined_reference_countries',
  PREDEFINED_REFERENCES_STATES = 'predefined_reference_states',
  PREDEFINED_REFERENCES_DISTRICTS = 'predefined_reference_districts',
  PREDEFINED_REFERENCES_CITIES = 'predefined_reference_cities',
  PUSH_NOTIFICATION_DEVICE = 'push_notification_devices',
  PROPOSALS = 'proposals',
  PROPOSAL_CONFIGURATIONS = 'proposal_configurations',
  // Q
  QUICK_ACTIONS = 'quick_actions',
  // R
  REFERENCE_CATEGORIES = 'reference_categories',
  REFERENCES = 'references',
  REFRESH_TOKENS = 'refresh_tokens',
  ROLES = 'roles',
  REMINDER = 'reminders',
  ROOMS = 'rooms',
  // S
  SETUP_BACKUP_SCHEDULES = 'setup_backup_schedules',
  SETUP_CLIENT = 'setup_clients',
  SETUP_COLOR_PALLETS = 'setup_color_palettes',
  SETUP_GENERAL = 'setup_generals',
  SETUP_IAM = 'setup_iams',
  SETUP_LANGUAGES = 'setup_languages',
  SETUP_CURRENCIES = 'setup_currencies',
  SETUP_MESSAGE_GROUPS = 'setup_message_groups',
  SETUP_MESSAGE_RULES = 'setup_message_rules',
  SETUP_MESSAGE_CONFIG = 'setup_message_config',
  SETUP_NOTIFICATION_CONFIG = 'setup_notification_configs',
  SETUP_MAILBOX_CONFIG = 'setup_mailbox_config',
  SETUP_PWA = 'setup_progressive_web_apps',
  SETUP_REFERENCE_MAPPINGS = 'setup_reference_mappings',
  SETUP_RELEASES = 'setup_releases',
  SETUP_EXTERNAL_SYSTEMS = 'setup_external_systems',
  SETUP_SECURITY = 'setup_securities',
  SETUP_SECURITY_WEB_HOOKS = 'setup_security_web_hooks',
  SETUP_STORAGE = 'setup_storages',
  SETUP_SUPPORT = 'setup_supports',
  SETUP_SYSTEM_VARIABLES = 'setup_system_variables',
  SUPPORT_RELEASES = 'support_releases',
  SETUP_MESSAGE = 'setup_messages',

  STORAGE = 'storages',
  STORAGE_ACCESS_TOKENS = 'storage_access_tokens',
  STORAGE_ENTITY = 'storage_entities',
  STORAGE_ENTITY_INTERNAL_SHARE = 'storage_entities_internal_shares',
  STORAGE_ENTITY_EXTERNAL_SHARE = 'storage_entities_external_shares',
  SUBMISSIONS = 'submissions',
  SUBMISSIONS_STATUS_CHANGES = 'submissions_status_changes',
  SUBMISSIONS_SEND_MESSAGES = 'submissions_send_messages',
  SUBSCRIBERS = 'subscribers',
  SUPPORT_PROJECTS = 'support_projects',
  SUPPORT_CUSTOMERS = 'support_customers',
  SUPPORT_TICKETS = 'support_tickets',
  SUPPORT_CONTACT_PERSONS = 'support_contact_persons',

  // T
  TEMPLATES = 'templates',
  TASK = 'tasks',

  // U
  USERS = 'users',
  // V
  VERIFICATION_TOKENS = 'verification_tokens',
  VACANCIES = 'vacancies',

  // W
  WIDGETS = 'widgets',
  WIDGET_LAYOUT = 'widget_layouts',
  WORKSTATIONS = 'workstations',
  WORKSTATION_CONFIGURATIONS = 'workstation_configurations',

  // Please add any el core config below

  // P
  PROJECT_MANAGEMENT = 'project_management',

  //H
  HOLIDAYS = 'HOLIDAYS',
  HOLIDAY_CONFIGURATIONS = 'holiday_configurations',
}
